/** Query parameter that opens a header dialog after navigation, used by mail and notification deep links. */
export const DIALOG_QUERY_PARAM = 'dialog';

export enum DeepLinkDialog {
  IMPERSONATION = 'impersonation',
}
